import { call, put } from "redux-saga/effects";

import { getCustomization } from "@multiweb/customization";
import { bridge } from "@multiweb/reactCore/bridge";
import { createAddRootNodes, CustomMethodDataType, LOAD_DATA, REFRESH_DATA } from "@multiweb/reactCore/datasource";
import { RecordType, SagaWithReturnType, SagaYieldReturn } from "@multiweb/types/react";
import type { IOWObjectList } from "../../../../../OW.Remoting/Remoting/DataTypes/IOWObjectList";
import { createRootNodesMaps, mapKeyToLowerArray } from "../utils";

const {
    getActivityParticipants,
} = bridge;

export const CUSTOM_DS_WF_PARTICIPANTS = "CUSTOM_DS_WF_PARTICIPANTS";

const loadParticipantsSaga: SagaWithReturnType<
    [string, IOWObjectList, string],
    RecordType[]
    > = function* loadParticipantsSaga(instanceId, objectList, actionId) {
        const rawData: SagaYieldReturn<typeof getActivityParticipants> = yield call(getActivityParticipants, instanceId, objectList, actionId);
        const caseInsensitiveData: SagaYieldReturn<typeof mapKeyToLowerArray> = yield call(mapKeyToLowerArray, rawData);

        const rootNodesData: SagaYieldReturn<typeof createRootNodesMaps> = yield call(createRootNodesMaps, caseInsensitiveData as any);

        yield put(createAddRootNodes(actionId, rootNodesData));

        return caseInsensitiveData;
    };

type extendedFuncs = typeof LOAD_DATA | typeof REFRESH_DATA;
export type ParticipantCustomMethodDataType = CustomMethodDataType<extendedFuncs, string | IOWObjectList>;

getCustomization().core.datasource.registerMethodToDataSource(LOAD_DATA, loadParticipantsSaga, CUSTOM_DS_WF_PARTICIPANTS);
getCustomization().core.datasource.registerMethodToDataSource(REFRESH_DATA, loadParticipantsSaga, CUSTOM_DS_WF_PARTICIPANTS);
